export default {
    getSocialMenu: '/social/menu',
    getLatestSocialLink: 'social/property-link',
    getPublishInfo: 'social/publish-info',
    deletePublishedPost: 'social/property-link',
    logoffSocialAccount: 'social/logoff',
    getBoardList: 'social/pinterest/boards',
    addBoard: 'social/pinterest/boards',
    publishPost: 'social/publish',
    getSocialLoginUrl: 'social/check-login',
    loginInstagram: 'social/authentication',
    checkPublishStatus: 'social/publish-video/status',
    postFaceBookTemplate: 'social/templates?propertyId=:propertyId&moduleId=:moduleId',
    renderPostTextMessage: 'social/rendering-template',
    getAlbumByPage: 'social/albums',
    getAudioTemplates: '/social/audio-templates',
    uploadAudio: '/social/upload-audio',
    addAudio: '/social/add-audio',
    modifiedAudio: '/social/modify-audio',
    deleteAudio: '/social/delete-audio',
    saveTemplate: '/social/templates'
}